import React from "react";
import { NotificationProps } from "../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export const Notification : React.FC<NotificationProps> = ({notif, success}) => {

    if(success === null){
        return(
            <div className='notification-bar'>
                {notif}
            </div>
        );
    }

    return (
        <div className='notification-bar'>
            <div>
                {success ? (
                    <FontAwesomeIcon className='text-green-600' icon={faCheckCircle} />
                ): (
                    <FontAwesomeIcon className='text-red-500' icon={faTimesCircle} />
                )}&nbsp;
                {notif}
            </div>
        </div>
    );
};